import { render } from "./NewsItem.vue?vue&type=template&id=463dc307"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__